import Box from '@mui/material/Box';
import { ReactElement, ReactNode } from 'react';

import OptionHeader from '../OrderBuilder/components/OptionHeader';

export interface FieldsetWrapperProps {
  id?: string;
  children?: ReactNode;
  title?: string;
  error?: boolean;
  smallGutter?: boolean;
  subTitle?: string;
}

export default function FieldsetWrapper({
  id,
  title,
  children,
  error,
  smallGutter,
  subTitle,
}: FieldsetWrapperProps): ReactElement {
  return (
    <Box
      id={id}
      height="100%"
      component="fieldset"
      flexGrow={1}
      color={error ? 'error.main' : 'text.primary'}
      mb={smallGutter ? 2 : 6}
    >
      {title && <OptionHeader title={title} subTitle={subTitle} />}
      {children}
    </Box>
  );
}
